/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
==========================================================================================*/

import Vue from "vue";

// import msButton from "@/components/shared/button/MsButton.vue";
// Vue.component("msButton", msButton);
import MsSplitButton from "@/components/shared/button/MsSplitButtonFW.vue";
Vue.component(MsSplitButton.name, MsSplitButton);
// import msInput from "@/components/shared/input/MsInput.vue";
// Vue.component("msInput", msInput);
// import MsCheckbox from "@/components/shared/checkbox/MsCheckbox.vue";
// Vue.component(MsCheckbox.name, MsCheckbox);
// import MsRadio from "@/components/shared/radio/MsRadio.vue";
// Vue.component(MsRadio.name, MsRadio);
// import MsNumber from '@/components/shared/number/MsNumber.vue';
// Vue.component(MsNumber.name, MsNumber);
// import MsDatepicker from "@/components/shared/datepicker/MsDatePicker.vue";
// Vue.component(MsDatepicker.name, MsDatepicker);
// import MsTextarea from '@/components/shared/textarea/MsTextarea.vue';
// Vue.component(MsTextarea.name, MsTextarea);
// import VTooltip from '@/components/shared/tooltip';
// Vue.use(VTooltip);

// import msComboBox from '@/components/shared/combobox/MsCombobox.vue';
// Vue.component(msComboBox.name, msComboBox);
// import MsComboboxEnum from '@/components/shared/combobox/MsComboboxEnum.js';
// Vue.component(MsComboboxEnum.name, MsComboboxEnum);

import MsRadio from "@/components/controls/ms-radio/MsRadio.vue";
Vue.component(MsRadio.name, MsRadio);
import MsNumber from "@/components/controls/ms-number/MsNumber.vue";
Vue.component(MsNumber.name, MsNumber);
import MsDatePicker from "@/components/controls/ms-datepicker/MsDatePicker.vue";
Vue.component(MsDatePicker.name, MsDatePicker);
import MsTextarea from "@/components/controls/ms-textarea/MsTextarea.vue";
Vue.component(MsTextarea.name, MsTextarea);
// import VTooltip from "@/components/controls/tooltip";
// Vue.use(VTooltip);
import MsButton from "@/components/controls/ms-button/MsButton.vue";
Vue.component(MsButton.name, MsButton);
import MsCheckbox from "@/components/controls/ms-checkbox/MsCheckbox.vue";
Vue.component(MsCheckbox.name, MsCheckbox);
import MsInput from "@/components/controls/ms-input/MsInput.vue";
Vue.component(MsInput.name, MsInput);
import MsValidate from "@/components/controls/msValidate/msValidate.vue";
Vue.component(MsValidate.name, MsValidate);
import MsSelectBox from "@/components/controls/ms-select-box/MsSelectBox.vue"
Vue.component(MsSelectBox.name,MsSelectBox);
import MsLable from "@/components/controls/ms-lable/MsLable.vue";
Vue.component(MsLable.name, MsLable);
import MsHtmlEditor from "@/components/controls/ms-html-editor/MsHtmlEditor.vue";
Vue.component(MsHtmlEditor.name, MsHtmlEditor);
// import MsPopup from "@/components/controls/ms-html-editor/MsPopup.vue";
// Vue.component(MsPopup.name, MsPopup);
import MsPopup from "@/components/controls/ms-popup/MsPopup.vue";
Vue.component(MsPopup.name, MsPopup);
import MsPopover from "@/components/controls/ms-popover/MsPopover.vue";
Vue.component(MsPopover.name, MsPopover);
import MsPopup3 from "@/components/controls/ms-popup/MsPopup3.vue";
Vue.component("MsPopup3", MsPopup3);
import MsIcon from "@/components/controls/ms-icon/MsIcon.vue";
Vue.component(MsIcon.name, MsIcon);
import MsComboBoxDropdown from "@/components/controls/ms-combobox/MsComboBoxDropdown.vue";
Vue.component(MsComboBoxDropdown.name, MsComboBoxDropdown);
import MsComboBoxItem from "@/components/controls/ms-combobox/MsComboBoxItem.vue";
Vue.component(MsComboBoxItem.name, MsComboBoxItem);
import MsCombobox from "@/components/controls/ms-combobox/MsCombobox.vue";
Vue.component(MsCombobox.name, MsCombobox);
import msComboboxMultiple from "@/components/controls/ms-combobox-multiple/msComboboxMultiple.vue";
Vue.component(msComboboxMultiple.name, msComboboxMultiple);

import MsTextBorder from "@/components/controls/ms-text-border/MsTextBorder.vue";
Vue.component(MsTextBorder.name, MsTextBorder);
import MsLabelRequire from "@/components/controls/ms-label-require/MsLabelRequire.vue";
Vue.component("MsLabelRequire", MsLabelRequire);
import RequestLoadingIndicator from "@/components/controls/request-loading-indicator/RequestLoadingIndicator.vue";
Vue.component(RequestLoadingIndicator.name, RequestLoadingIndicator);
const MsTooltip = () =>
  import(
    /* webpackChunkName:'MsTooltip' */ "@/components/controls/ms-tooltip/MsTooltip.vue"
  );
Vue.component("MsTooltip", MsTooltip);
import MsDropDown from "@/components/controls/ms-dropdown/MsDropDown.vue";
Vue.component(MsDropDown.name, MsDropDown);
import MsDropDownItem from "@/components/controls/ms-dropdown/MsDropDownItem.vue";
Vue.component(MsDropDownItem.name, MsDropDownItem);
import MsDropDownMenu from "@/components/controls/ms-dropdown/MsDropDownMenu.vue";
Vue.component(MsDropDownMenu.name, MsDropDownMenu);
import MsFilter from "@/components/controls/ms-filter/MsFilter.vue";
Vue.component(MsFilter.name, MsFilter);
import MsTab from "@/components/controls/ms-tab/MsTab.vue";
Vue.component(MsTab.name, MsTab);
import MsRow from "@/components/controls/ms-row/MsRow.vue";
Vue.component(MsRow.name, MsRow);
import MsCol from "@/components/controls/ms-col/MsCol.vue";
Vue.component(MsCol.name, MsCol);
import MsTagbox from "@/components/controls/ms-tagbox/MsTagbox.vue";
Vue.component(MsTagbox.name, MsTagbox);
import VTooltip from "@/components/shared/tooltip";
Vue.use(VTooltip);

import BaseCotentArea from "@/views/Base/BaseCotentArea.vue";
Vue.component(BaseCotentArea.name, BaseCotentArea);


import MsOrganizationUnit from "@/components/controls/ms-common/ms-organization-unit/MsOrganizationUnit.vue";
Vue.component(MsOrganizationUnit.name, MsOrganizationUnit);

// import MsGrid from "@/components/controls/ms-grid/MsGrid.vue";
// Vue.component(MsGrid.name, MsGrid);

// import MsInput from "@/components/controls/ms-input/MsInput.vue";
// Vue.component(MsInput.name, MsInput);
//phím tắt
import '@/components/shared/shortkey/MsShortkey';